import { useContext } from 'react';

import {
    Button,
    Card,
    Col,
    Container,
    Form,
    Row,
} from 'react-bootstrap';

import {
    BrandingContext,
    GeoContext,
    InsuranceDataContext,
    LayoutContext,
    NotificationsContext,
    SessionContext,
} from '../libs/contexts';

export const Policy = () => {

    const { layout, setLayout } = useContext(LayoutContext);

    const validateScreen = () => {

        let requirements = { ...layout.requirements };
        requirements.policy = "pass";

        let newLayout = {
            requirements: requirements
        };
        setLayout(newLayout);
    }

    return (
        <>
            this is the policy screen
        </>
    )

}

